import { fetchSingleModel } from 'actions';
import { fetchSingleOutcome } from 'actions/outcome';
import { fetchSingleRuleGroup } from 'actions/ruleGroup';
import BulkOutcomesPage from 'components/BulkOutcomesPage';
import OutcomeManagerStarship from 'components/OutcomeManagerStarship';
import OutcomeStarship from 'components/OutcomeStarship';
import { RouteSpec, SuperRouteSpec } from 'types';

const outcomeRoutes: (RouteSpec | SuperRouteSpec)[] = [
  {
    name: 'rule-group-outcome',
    path: '/:customerDomain/rule-group/:ruleId?/outcome',
    component: OutcomeManagerStarship,
    exact: true,
    private: true,
    permissions: 'outcomes.list',
    data: {
      idFromPath: true,
      actions: [fetchSingleRuleGroup],
    },
  },

  {
    name: 'rule-group-outcome-id',
    path: '/:customerDomain/rule-group/:ruleId?/outcome/:outcomeId',
    component: OutcomeStarship,
    private: true,
    permissions: 'outcomes.retrieve',
    data: {
      idFromPath: true,
      actions: [fetchSingleOutcome],
      params: {
        from_bulk: {
          defaultValue: 'false',
        },
      },
    },
  },

  {
    name: 'model-rule-group-outcome-id',
    path: '/:customerDomain/model/:modelId/rule-group/:ruleId?/outcome/:outcomeId',
    component: OutcomeStarship,
    private: true,
    permissions: 'outcomes.retrieve',
    data: {
      idFromPath: true,
      actions: [fetchSingleOutcome],
      params: {
        from_bulk: {
          defaultValue: 'false',
        },
      },
    },
  },

  {
    name: 'customer-model-outcomes-manager',
    path: '/:customerDomain/model/:modelId/outcome',
    component: BulkOutcomesPage,
    private: true,
    permissions: 'outcomes.retrieve',
    data: {
      idFromPath: true,
      actions: [fetchSingleModel],
      params: {
        rule_uuids: {
          defaultValue: [],
          list: true,
        },
        from_customer: {
          defaultValue: '',
        },
      },
    },
  },
];

export default outcomeRoutes;
